module.exports = __webpack_public_path__ + "img/6.febf8824.jpg";